import Topics from './topics'

export default Topics
